export const Numerator = ({ value, record }) => value == null ? '' : Math.round(value*100)/100;
